import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProductCard } from '../components/ProductCard';
import { useStore } from '../store';
import { api } from '../services/api';

export const CategoryDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const { selectedCategory, products, isLoading, error, setSelectedCategory, setProducts, setLoading, setError } = useStore();

  useEffect(() => {
    const fetchCategoryAndProducts = async () => {
      try {
        setLoading(true);
        const [categoryResponse, productsResponse] = await Promise.all([
          api.get(`/categories/${slug}`),
          api.get(`/categories/${slug}/products`)
        ]);
        setSelectedCategory(categoryResponse.data.data);
        setProducts(productsResponse.data.data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch category details');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchCategoryAndProducts();
    }
  }, [slug, setSelectedCategory, setProducts, setLoading, setError]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-semibold text-red-600 mb-4">Error</h2>
        <p className="text-gray-600">{error}</p>
      </div>
    );
  }

  if (!selectedCategory) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Category Not Found</h2>
        <p className="text-gray-600">The requested category could not be found.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">{selectedCategory.name}</h1>
        {selectedCategory.description && (
          <p className="text-gray-600">{selectedCategory.description}</p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}; 